import React from "react";

interface TablePaginationProps {
  page: number;
  totalPages: number;
  totalItems: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  itemLabel?: string;
}

export const TablePagination: React.FC<TablePaginationProps> = ({
  page,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
  itemLabel = "rows",
}) => {
  const safeTotalPages = Math.max(1, totalPages);
  const safePage = Math.min(Math.max(1, page), safeTotalPages);
  const start = totalItems === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const end = Math.min(safePage * pageSize, totalItems);

  return (
    <div className="flex items-center justify-between border-t border-cardborder bg-gray-50 px-4 py-3">
      <span className="text-xs text-gray-600">
        Showing {start}–{end} of {totalItems} {itemLabel}
      </span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, safePage - 1))}
          disabled={safePage === 1}
          className={`px-3 py-1.5 text-xs font-medium transition-colors ${
            safePage === 1
              ? "cursor-not-allowed border border-gray-200 text-gray-400"
              : "border border-gray-300 text-gray-700 hover:bg-white"
          }`}
        >
          Previous
        </button>
        <button
          type="button"
          onClick={() => onPageChange(Math.min(safeTotalPages, safePage + 1))}
          disabled={safePage === safeTotalPages}
          className={`px-3 py-1.5 text-xs font-medium transition-colors ${
            safePage === safeTotalPages
              ? "cursor-not-allowed border border-gray-200 text-gray-400"
              : "border border-gray-300 text-gray-700 hover:bg-white"
          }`}
        >
          Next
        </button>
      </div>
    </div>
  );
};
